<template>
  <quote-order-form
    v-if="localOrder"
    ref="quoteOrderForm"
    :full-width="halfWidth"
    :invoices="invoices"
    :order="localOrder"
    @preview="$emit('preview', $event)"
  />
</template>

<script setup lang="ts">
import cloneDeep from 'lodash.clonedeep'
import QuoteOrderForm from '@/components/quotes/quote-order-form.vue'
import type { Invoice, Order } from '@quotetome/materials-api'

export interface Props {
  halfWidth?: boolean
  invoices?: Invoice[]
  order: Order
}
const props = defineProps<Props>()
defineEmits(['preview'])

const localOrder = ref()

const cloneObjects = () => {
  localOrder.value = cloneDeep(props.order)
}

const quoteFormRef = useTemplateRef('quoteOrderForm')
const beforeTransition = (_action: any, abort: () => void) => {
  const form = quoteFormRef.value as any
  if (form && !props.order.cancelled) {
    if (!form.isValid()) {
      abort()
      return undefined
    }
    return form.submit(true)
  }
  return undefined
}

const refresh = async () => {
  cloneObjects()

  const form = quoteFormRef.value as any
  if (form) {
    // Wait for cloned objects to propagate before setting items
    await nextTick()
    form.setItems()
  }
}

onMounted(cloneObjects)

defineExpose({ beforeTransition, refresh })
</script>
